import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';
import '@campact/camper/core/CmprAlertBanner';
import '@campact/camper/core/CmprButton.css';
import '@campact/camper/core/CmprCopyButton';
import '@campact/camper/core/CmprFormControl.css';
import '@campact/camper/core/CmprFormLabel.css';
import '@campact/camper/core/CmprFormHint';
import '@campact/camper/core/CmprSharingButton';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';
import Dependency from '@cta/frontend/javascripts/dependency';
import ContactCallGateway from './gateways/ContactCallGateway';

import { installErrorHandler } from '@appsignal/stimulus';
import appsignal from '@cta/shared/appsignal';
import { Application } from '@hotwired/stimulus';
import Rails from '@rails/ujs';
import ContactIntentionsController from './controllers/contact_intentions_controller';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('contact-intentions', ContactIntentionsController);

AppBoot.start(App, (params) => {
  Dependency.register('ContactCallGateway', new ContactCallGateway(params));
});
